<template>
    <selector-popup
            ref="popup"
            header="What would you like to do?"
            :items="items"
    >
        <i slot="descriptionTop">
            You can either <strong>Create New Chat</strong>
            or <strong>Join last Chat "{{ lastChat.name }}"</strong>
            created by
            <strong v-if="lastChat.created_by"><simple-link :target="lastChat.created_by"></simple-link></strong>
            on {{ lastChat.created_at | gbdate }}
        </i>
        <template slot="footer">
            <button @click="back" type="button" class="btn btn-mm  btn-primary">Cancel</button>
        </template>
    </selector-popup>
</template>

<script>
    import SelectorPopup from "../../../../vue/common_components/SelectorPopup/SelectorPopup";

    export default {
        name: "GroupChatCreateOrJoinLastPopup",
        components: {SelectorPopup},
        mixins: [],
        data() {
            return {
                lastChat: {},
            };
        },
        computed: {
            items() {
                return [
                    {
                        label: 'Join<br/>last Chat',
                        iconClass: 'fa fa-sign-in',
                        action: 'select',
                        selection: 'join',
                    },
                    {
                        label: 'Create<br>New Chat',
                        iconClass: 'fa fa-plus',
                        action: 'select',
                        selection: 'create',
                    },
                ];
            }
        },
        methods: {
            show(lastChat) {
                this.lastChat = lastChat;
                return new Promise((resolve, reject) => {
                    this.reject = reject;
                    this.resolve = resolve;
                    this.$refs.popup.show()
                        .then(item => {
                            resolve({
                                action: 'select',
                                selection: item.selection,
                            });

                        }, reason => {
                            reject(reason);
                        });
                });
            },
            back() {
                this.reject('back');
            },
        },
    };
</script>

<style scoped>

</style>